import React, { useEffect, useState, useRef } from 'react'
import { GetChatLog, Get_tickets, update_tickets } from '../../services/data'
import DateTimeFormat from '../../util/DateTimeformat'
import Conversation from './conversation'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { apiFetch } from '../../services/apihelper'
import '../../styles/maincontent.css'
import { toast, ToastContainer } from 'react-toastify'
import ReplyTextEditor from './replytexteditor'
import validateJSON from '../../util/jsonvalidation'
import Loader from '../../components/loader'
import console_log from '../../util/consolelog'
import IonIcon from '@reacticons/ionicons'
import { format } from 'date-fns' // Import date-fns for robust date formatting
import Cookies from 'js-cookie'
import { useAuth } from '../../context/logincontext'
import { useLocation, useParams } from 'react-router-dom'

const MainComponent = () => {
  const chatLog = new GetChatLog()
  const [CustomerChatList, SetCustomerChatList] = useState([])
  const [groupedChats, setGroupedChats] = useState({})
  const [Initialactive, SetInitialactive] = useState('')
  const [selectedDate, setSelectedDate] = useState(null) // This state isn't directly used for filtering now, dateRange is.
  const [showModal, setShowModal] = useState(false)
  const [deletingChat, setDeletingChat] = useState(null) // This state isn't used
  const [ticketsList, setTicketList] = useState([])
  const [isOpen, setIsOpen] = useState(false) // This state isn't used
  const [selectedValue, setSelectedValue] = useState([]) // This state isn't used
  const [inputValue, setInputValue] = useState('') // This state isn't used
  const dropdownMenuRef = useRef(null) // This ref isn't used with current dropdown logic
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null) // This state isn't used
  const contentListRef = useRef(null) // This ref isn't used
  const [sortlist, setSortlist] = useState('') // Used for ticket filtering
  const [checkfilter, setCheckfilter] = useState('') // Used for ticket filtering
  const [ticketemail, Setticketemail] = useState('')
  const [showtoast, setshowtoast] = useState(false)
  const [loadingChat, setLoadingChat] = useState(false)
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const {userdata} = useAuth();
  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const store_id = getStoreIdFromUrl()

  // Effect for displaying success toast after chat deletion and reloading list
  useEffect(() => {
    if (showtoast) {
      // Only run if showtoast is true
      const checkchatlistAndShowToast = async () => {
        const storeID = store_id
        const cust_id = localStorage.getItem('chatlog_customer_id')

        // Re-fetch the first page of chats after deletion
        const customerChatlist = await chatLog.Get_Chat_List(
          storeID,
          cust_id,
          null,
          1, // Always load the first page after deletion
          10,
          startDate ? format(startDate, 'yyyy-MM-dd') : null,
          endDate ? format(endDate, 'yyyy-MM-dd') : null
        )

        if (customerChatlist.data.length === 0) {
          // If no chats left, reload the window or navigate away
          window.location.reload()
        } else {
          toast.success(localStorage.getItem('deletechat'), {
            position: 'bottom-center',
            onClose: () => {
              localStorage.removeItem('deletechat')
              setshowtoast(false)
            }
          })
          SetCustomerChatList(customerChatlist.data)
          setHasMore(customerChatlist.data.length === 10)
          // Set the first chat as active after reload if there are chats
          if (customerChatlist.data.length > 0) {
            SetInitialactive(customerChatlist.data[0].chat_id)
            localStorage.setItem(
              'chatlist_customer_id',
              customerChatlist.data[0].chat_id
            )
            // Manually dispatch event to ensure Conversation component updates
            window.dispatchEvent(
              new CustomEvent('chatlist_customer_id', { detail: true })
            )
          }
        }
      }

      checkchatlistAndShowToast()
    }
  }, [showtoast]) // Depend on showtoast

  // Ticket filtering logic (remains unchanged as it's separate from chat filtering)
  const handleSelectChange = async event => {
    const value = event.target.value
    const storeID = store_id
    const cust_id = localStorage.getItem('chatlog_customer_id')
    const user_id = validateJSON(userdata).id
    // const user_id = validateJSON(Cookies.get('user')).id

    if (value === '') {
      setCheckfilter('')
      setSortlist(value)
      const ticketsListdata = await Get_tickets(storeID, cust_id, user_id)
      setTicketList(ticketsListdata.data)
    } else {
      setCheckfilter(value)
      setSortlist(value)
      const ticketsListdata = await Get_tickets(
        storeID,
        cust_id,
        user_id,
        '',
        value
      )
      setTicketList(ticketsListdata.data)
    }
  }

  // Main function to load chats with pagination and date filtering
  const loadChats = async (pageNum = 1, reset = false) => {
    setLoadingChat(true) // Start loading
    try {
      const storeID = store_id
      const cust_id = localStorage.getItem('chatlog_customer_id')

      // Format startDate and endDate using date-fns
      const formattedStartDate = startDate
        ? format(startDate, 'yyyy-MM-dd')
        : null
      const formattedEndDate = endDate ? format(endDate, 'yyyy-MM-dd') : null

      console.log(
        'Fetching chats with Date Range:',
        formattedStartDate,
        'to',
        formattedEndDate
      )

      const customerChatlist = await chatLog.Get_Chat_List(
        storeID,
        cust_id,
        null,
        pageNum,
        10,
        formattedStartDate,
        formattedEndDate
      )

      if (customerChatlist.success) {
        if (reset) {
          SetCustomerChatList(customerChatlist.data)
          if (customerChatlist.data.length > 0) {
            const firstChatId = customerChatlist.data[0].chat_id
            SetInitialactive(firstChatId)
            localStorage.setItem('chatlist_customer_id', firstChatId)
            // Dispatch event to ensure Conversation component updates
            window.dispatchEvent(
              new CustomEvent('chatlist_customer_id', { detail: true })
            )
          } else {
            // If no chats are found, clear the active chat
            SetInitialactive('')
            localStorage.removeItem('chatlist_customer_id')
            window.dispatchEvent(
              new CustomEvent('chatlist_customer_id', { detail: false })
            ) // Indicate no active chat
          }
        } else {
          SetCustomerChatList(prev => [...prev, ...customerChatlist.data])
        }
        setHasMore(customerChatlist.data.length === 10)
      } else {
        console.error(
          'API call for Get_Chat_List failed:',
          customerChatlist.message
        )
        // Optionally show an error toast
        toast.error('Failed to load chats. Please try again.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error loading chats:', error)
      toast.error('An error occurred while loading chats.', {
        position: 'bottom-center'
      })
    } finally {
      setLoadingChat(false) // End loading
    }
  }

  const loadMoreChats = async () => {
    if (isLoadingMore || !hasMore) return

    setIsLoadingMore(true)
    const nextPage = page + 1 // Correctly get the next page number
    setPage(nextPage) // Update page state
    await loadChats(nextPage, false) // Load more chats without resetting
    setIsLoadingMore(false)
  }

  // Initial load of chats when component mounts or customer ID changes
  useEffect(() => {
    const handleGetNewCustomerID = async event => {
      // If customer ID changed or delete reload, reset to page 1 and load chats
      if (event.detail === true) {
        if (
          localStorage.getItem('chatlog_customer_id') &&
          store_id
        ) {
          setPage(1) // Reset page to 1
          await loadChats(1, true) // Load chats for the new customer ID, reset list
          // Set ticket email
          Setticketemail(localStorage.getItem('chatlog_customer_email'))
          setDateRange([null, null])
        }
      }
    }

    // Initial load when component first mounts (if IDs exist)
    if (
      localStorage.getItem('chatlog_customer_id') &&
      store_id
    ) {
      loadChats(1, true)
      Setticketemail(localStorage.getItem('chatlog_customer_email'))
    }

    window.addEventListener('deletereload', handleGetNewCustomerID)
    window.addEventListener('chatlog_customer_id', handleGetNewCustomerID)

    return () => {
      window.removeEventListener('chatlog_customer_id', handleGetNewCustomerID)
      window.removeEventListener('deletereload', handleGetNewCustomerID)
    }
  }, []) // Empty dependency array means this runs once on mount

  // Effect to re-load chats when dateRange changes
  useEffect(() => {
    if (
      localStorage.getItem('chatlog_customer_id') &&
      store_id
    ) {
      setPage(1) // Reset to first page when date range changes
      loadChats(1, true) // Always reset to page 1 when date range changes
    }
  }, [dateRange]) // Watch dateRange for changes

  // Effect to group chats by date whenever CustomerChatList changes
  useEffect(() => {
    const groupChatsByDate = () => {
      const grouped = CustomerChatList.reduce((acc, item) => {
        const date = new Date(item.createdAt)
        const formattedDate = date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })
        if (!acc[formattedDate]) {
          acc[formattedDate] = []
        }
        acc[formattedDate].push(item)
        return acc
      }, {})

      setGroupedChats(prevGroupedChats => {
        const prevKeys = Object.keys(prevGroupedChats)
        const currentKeys = Object.keys(grouped)
        if (
          prevKeys.length !== currentKeys.length ||
          !prevKeys.every(key => currentKeys.includes(key)) ||
          !prevKeys.every(
            key =>
              JSON.stringify(prevGroupedChats[key]) ===
              JSON.stringify(grouped[key])
          )
        ) {
          return grouped
        }
        return prevGroupedChats
      })
    }

    if (CustomerChatList.length > 0) {
      groupChatsByDate()
    } else {
      setGroupedChats({}) // Clear grouped chats if CustomerChatList is empty
    }
  }, [CustomerChatList])

  // Effect to update Conversation component when Initialactive changes
  useEffect(() => {
    if (Initialactive) {
      localStorage.setItem('chatlist_customer_id', Initialactive)
      window.dispatchEvent(
        new CustomEvent('chatlist_customer_id', { detail: true })
      )
    }
  }, [Initialactive])

  const handleActiveChatid = (id, messageDate) => {
    // Only update if the active chat is different

    setLoadingChat(true) // Start loading for conversation
    SetInitialactive(id)
    // The useEffect above will handle setting localStorage and dispatching the event
    setTimeout(() => setLoadingChat(false), 300) // Simulate loading time
  }

  const handleDateRangeChange = dates => {
    setDateRange(dates)
    // The useEffect watching `dateRange` will handle resetting page and reloading chats.
  }

  const DatepickerCustomInput = React.forwardRef(
    ({ value, onClick, onChange }, ref) => (
      <div className='relative w-full max-w-[300px]'>
        <div
          className='w-full h-[39px] cursor-pointer border-[0.4px] gap-2 border-[#C6C6C6] border-opacity-[50%] rounded-[17px] flex justify-start px-4 items-center bg-[#FFFFFF80] focus:outline-none selectdate'
          onClick={onClick}
          ref={ref}
        >
          <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M16.875 4.49971C16.875 3.90297 16.6379 3.33067 16.216 2.90871C15.794 2.48676 15.2217 2.2497 14.625 2.2497H14.0625V1.70302C14.0625 1.40033 13.8298 1.14052 13.5271 1.12541C13.451 1.12174 13.375 1.13356 13.3037 1.16014C13.2323 1.18672 13.1671 1.2275 13.112 1.28003C13.0568 1.33256 13.0129 1.39573 12.983 1.46572C12.953 1.53571 12.9375 1.61106 12.9375 1.6872V2.2497H5.0625V1.70302C5.0625 1.40033 4.82977 1.14052 4.52707 1.12541C4.45101 1.12174 4.37501 1.13356 4.30365 1.16014C4.2323 1.18672 4.16708 1.2275 4.11196 1.28003C4.05684 1.33256 4.01295 1.39573 3.98296 1.46572C3.95297 1.53571 3.93751 1.61106 3.9375 1.6872V2.2497H3.375C2.77826 2.2497 2.20597 2.48676 1.78401 2.90871C1.36205 3.33067 1.125 3.90297 1.125 4.49971V4.92158C1.125 4.95888 1.13982 4.99464 1.16619 5.02102C1.19256 5.04739 1.22833 5.06221 1.26562 5.06221H16.7344C16.7717 5.06221 16.8074 5.04739 16.8338 5.02102C16.8602 4.99464 16.875 4.95888 16.875 4.92158V4.49971Z'
              fill='#565656'
            />
            <path
              d='M1.125 14.6247C1.125 15.2214 1.36205 15.7937 1.78401 16.2157C2.20597 16.6377 2.77826 16.8747 3.375 16.8747H14.625C15.2217 16.8747 15.794 16.6377 16.216 16.2157C16.6379 15.7937 16.875 15.2214 16.875 14.6247V6.29267C16.875 6.2647 16.8639 6.23787 16.8441 6.2181C16.8243 6.19832 16.7975 6.1872 16.7695 6.1872H1.23047C1.2025 6.1872 1.17567 6.19832 1.15589 6.2181C1.13611 6.23787 1.125 6.2647 1.125 6.29267V14.6247ZM13.2188 7.3122C13.3856 7.3122 13.5488 7.36169 13.6875 7.4544C13.8263 7.54711 13.9344 7.67889 13.9983 7.83307C14.0621 7.98724 14.0788 8.15689 14.0463 8.32056C14.0137 8.48423 13.9334 8.63458 13.8154 8.75258C13.6974 8.87058 13.547 8.95094 13.3834 8.98349C13.2197 9.01605 13.05 8.99934 12.8959 8.93548C12.7417 8.87162 12.6099 8.76347 12.5172 8.62472C12.4245 8.48596 12.375 8.32283 12.375 8.15596C12.375 7.93218 12.4639 7.71757 12.6221 7.55933C12.7804 7.4011 12.995 7.3122 13.2188 7.3122ZM13.2188 10.1247C13.3856 10.1247 13.5488 10.1742 13.6875 10.2669C13.8263 10.3596 13.9344 10.4914 13.9983 10.6456C14.0621 10.7997 14.0788 10.9694 14.0463 11.1331C14.0137 11.2967 13.9334 11.4471 13.8154 11.5651C13.6974 11.6831 13.547 11.7634 13.3834 11.796C13.2197 11.8285 13.05 11.8118 12.8959 11.748C12.7417 11.6841 12.6099 11.576 12.5172 11.4372C12.4245 11.2985 12.375 11.1353 12.375 10.9685C12.375 10.7447 12.4639 10.5301 12.6221 10.3718C12.7804 10.2136 12.995 10.1247 13.2188 10.1247ZM10.4062 7.3122C10.5731 7.3122 10.7363 7.36169 10.875 7.4544C11.0138 7.54711 11.1219 7.67889 11.1858 7.83307C11.2496 7.98724 11.2663 8.15689 11.2338 8.32056C11.2012 8.48423 11.1209 8.63458 11.0029 8.75258C10.8849 8.87058 10.7345 8.95094 10.5709 8.98349C10.4072 9.01605 10.2375 8.99934 10.0834 8.93548C9.92919 8.87162 9.79741 8.76347 9.7047 8.62472C9.61199 8.48596 9.5625 8.32283 9.5625 8.15596C9.5625 7.93218 9.6514 7.71757 9.80963 7.55933C9.96786 7.4011 10.1825 7.3122 10.4062 7.3122ZM10.4062 10.1247C10.5731 10.1247 10.7363 10.1742 10.875 10.2669C11.0138 10.3596 11.1219 10.4914 11.1858 10.6456C11.2496 10.7997 11.2663 10.9694 11.2338 11.1331C11.2012 11.2967 11.1209 11.4471 11.0029 11.5651C10.8849 11.6831 10.7345 11.7634 10.5709 11.796C10.4072 11.8285 10.2375 11.8118 10.0834 11.748C9.92919 11.6841 9.79741 11.576 9.7047 11.4372C9.61199 11.2985 9.5625 11.1353 9.5625 10.9685C9.5625 10.7447 9.6514 10.5301 9.80963 10.3718C9.96786 10.2136 10.1825 10.1247 10.4062 10.1247ZM10.4062 12.9372C10.5731 12.9372 10.7363 12.9867 10.875 13.0794C11.0138 13.1721 11.1219 13.3039 11.1858 13.4581C11.2496 13.6122 11.2663 13.7819 11.2338 13.9456C11.2012 14.1092 11.1209 14.2596 11.0029 14.3776C10.8849 14.4956 10.7345 14.5759 10.5709 14.6085C10.4072 14.641 10.2375 14.6243 10.0834 14.5605C9.92919 14.4966 9.79741 14.3885 9.7047 14.2497C9.61199 14.111 9.5625 13.9478 9.5625 13.781C9.5625 13.5572 9.6514 13.3426 9.80963 13.1843C9.96786 13.0261 10.1825 12.9372 10.4062 12.9372ZM7.59375 10.1247C7.76063 10.1247 7.92376 10.1742 8.06251 10.2669C8.20127 10.3596 8.30941 10.4914 8.37327 10.6456C8.43713 10.7997 8.45384 10.9694 8.42129 11.1331C8.38873 11.2967 8.30837 11.4471 8.19037 11.5651C8.07237 11.6831 7.92203 11.7634 7.75836 11.796C7.59469 11.8285 7.42504 11.8118 7.27086 11.748C7.11669 11.6841 6.98491 11.576 6.8922 11.4372C6.79948 11.2985 6.75 11.1353 6.75 10.9685C6.75 10.7447 6.83889 10.5301 6.99713 10.3718C7.15536 10.2136 7.36997 10.1247 7.59375 10.1247ZM7.59375 12.9372C7.76063 12.9372 7.92376 12.9867 8.06251 13.0794C8.20127 13.1721 8.30941 13.3039 8.37327 13.4581C8.43713 13.6122 8.45384 13.7819 8.42129 13.9456C8.38873 14.1092 8.30837 14.2596 8.19037 14.3776C8.07237 14.4956 7.92203 14.5759 7.75836 14.6085C7.59469 14.641 7.42504 14.6243 7.27086 14.5605C7.11669 14.4966 6.98491 14.3885 6.8922 14.2497C6.79948 14.111 6.75 13.9478 6.75 13.781C6.75 13.5572 6.83889 13.3426 6.99713 13.1843C7.15536 13.0261 7.36997 12.9372 7.59375 12.9372ZM4.78125 10.1247C4.94813 10.1247 5.11126 10.1742 5.25001 10.2669C5.38877 10.3596 5.49691 10.4914 5.56077 10.6456C5.62463 10.7997 5.64134 10.9694 5.60879 11.1331C5.57623 11.2967 5.49587 11.4471 5.37787 11.5651C5.25987 11.6831 5.10953 11.7634 4.94586 11.796C4.78219 11.8285 4.61254 11.8118 4.45836 11.748C4.30419 11.6841 4.17241 11.576 4.0797 11.4372C3.98699 11.2985 3.9375 11.1353 3.9375 10.9685C3.9375 10.7447 4.02639 10.5301 4.18463 10.3718C4.34286 10.2136 4.55747 10.1247 4.78125 10.1247ZM4.78125 12.9372C4.94813 12.9372 5.11126 12.9867 5.25001 13.0794C5.38877 13.1721 5.49691 13.3039 5.56077 13.4581C5.62463 13.6122 5.64134 13.7819 5.60879 13.9456C5.57623 14.1092 5.49587 14.2596 5.37787 14.3776C5.25987 14.4956 5.10953 14.5759 4.94586 14.6085C4.78219 14.641 4.61254 14.6243 4.45836 14.5605C4.30419 14.4966 4.17241 14.3885 4.0797 14.2497C3.98699 14.111 3.9375 13.9478 3.9375 13.781C3.9375 13.5572 4.02639 13.3426 4.18463 13.1843C4.34286 13.0261 4.55747 12.9372 4.78125 12.9372Z'
              fill='#565656'
            />
          </svg>

          <p className='font-medium text-[10px] leading-[13.66px] text-[#565656] truncate max-w-[140px] overflow-hidden whitespace-nowrap'>
            {value || 'Select date range'}
          </p>
        </div>
        {value && (
          <button
            onClick={e => {
              e.stopPropagation()
              // Clear the date range
              handleDateRangeChange([null, null])
            }}
            className='absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <line x1='18' y1='6' x2='6' y2='18'></line>
              <line x1='6' y1='6' x2='18' y2='18'></line>
            </svg>
          </button>
        )}
      </div>
    )
  )

  const handleDeleteClick = () => {
    setShowModal(true)
  }

  const handleConfirmDelete = async () => {
    try {
      const response = await apiFetch(`chatlog/batch/delete/chat_id`, {
        method: 'POST',
        body: JSON.stringify({
          ids: [localStorage.getItem('chatlist_customer_id')]
        })
      })

      if (response.success) {
        localStorage.setItem('deletechat', response.message)
        setshowtoast(true) // This will trigger the useEffect to re-fetch chats and show toast
        setShowModal(false)
        // The useEffect watching `showtoast` will handle the reload
      } else {
        toast.error(response.message || 'Failed to delete chat.', {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error deleting chat:', error)
      toast.error('An error occurred while deleting the chat.', {
        position: 'bottom-center'
      })
    }
  }

  const handleCancelDelete = () => {
    setShowModal(false)
  }

  return (
    <>
      <div className='flex flex-row flex-wrap w-full'>
        <div className=' h-auto bg-white my-5 rounded-[16px] relative flex flex-col w-full  '>
          {showModal && (
            <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
              <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] h-[240px] p-6 border-[1.6px] border-[#FFFFFF] shadow[-1px_0px_0px_0px_inset] relative'>
                <button
                  onClick={handleCancelDelete}
                  className='absolute top-4 right-4 text-[#373737] hover:text-[#252530] transition-colors'
                >
                  <IonIcon
                    name='close-outline'
                    style={{
                      fontSize: '26px',
                      width: '26px',
                      height: '26px'
                    }}
                  ></IonIcon>
                </button>

                <div className='flex flex-col items-center justify-center h-full'>
                  <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530] mb-2'>
                    Delete
                  </p>
                  <p className='font-[400] text-[16px] leading-[21px] mb-6'>
                    Are you sure want to delete
                  </p>
                  <div className='flex gap-4'>
                    <button
                      onClick={handleCancelDelete}
                      className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF] hover:bg-[#373737] transition-colors'
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleConfirmDelete}
                      className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF] hover:bg-[#C21F00] transition-colors'
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className='border-b-[1px] flex justify-end items-center pr-5 pl-5 cursor-pointer border-[#E5E9EB] w-full h-[70px]'>
            <IonIcon
              name='trash-outline'
              style={{
                fontSize: '14px',
                color: '#373737',
                padding: '5px',
                borderRadius: '50%',
                backgroundColor: '#FAFAFA',
                border: '1px solid #D1D1D1',
                width: '16px',
                height: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={handleDeleteClick}
            />
          </div>

          <div className='flex flex-1 flex-col md:flex-row '>
            <div className='border-r-[1px] border-[#D7D7D7] min-w-[240px] h-full py-5 px-5'>
              <div className='mt-7'>
                <div className='w-full mb-5'>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={handleDateRangeChange}
                    customInput={<DatepickerCustomInput />}
                    dateFormat='MMMM dd, yyyy'
                    placeholderText='Select date range'
                    isClearable={true}
                  />
                </div>

                <div className='flex flex-col gap-2 overflow-y-auto max-h-[220px] pr-2 scrollbar-custom'>
                  {Object.keys(groupedChats).length > 0 ? (
                    Object.keys(groupedChats).map(date => (
                      <div key={date} className='w-full mb-3'>
                        <p className='text-xs font-semibold text-gray-600 ml-2 mb-1'>
                          {date}
                        </p>

                        <ul className='space-y-1'>
                          {groupedChats[date].map((item, index) => {
                            const isActive = Initialactive === item.chat_id
                            return (
                              <li
                                key={item.chat_id || index}
                                onClick={() =>
                                  handleActiveChatid(
                                    item.chat_id,
                                    item.createdAt
                                  )
                                }
                                className={`w-full px-4 py-2 rounded-lg cursor-pointer transition-colors duration-150
          ${isActive ? 'bg-[#F0EEEE] hover:bg-[#e0e0e0]' : 'hover:bg-gray-100'}
        `}
                              >
                                <p className='text-sm font-medium text-gray-800 truncate whitespace-nowrap overflow-hidden max-w-[200px]'>
                                  {item.content}
                                </p>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    ))
                  ) : (
                    <p className='text-[12px] text-gray-500 text-center py-4'>
                      No chats found for the selected date range
                    </p>
                  )}
                  {hasMore && (
                    <button
                      onClick={loadMoreChats}
                      disabled={isLoadingMore}
                      className={`rounded-[59px] p-2 text-white text-[14px] ${
                        isLoadingMore
                          ? 'bg-gray-600 cursor-not-allowed'
                          : 'bg-[#232328]'
                      }`}
                    >
                      {isLoadingMore ? 'Loading...' : 'Load More'}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className='flex-1 w-full h-full relative'>
              {loadingChat ? (
                <div className='w-full h-full flex justify-center items-center'>
                  <p className='text-gray-500'>
                    <Loader />
                  </p>
                </div>
              ) : (
                <Conversation
                  chatlistId={localStorage.getItem('chatlist_customer_id')}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer /> {/* Ensure ToastContainer is rendered */}
    </>
  )
}

export default MainComponent
